import React from 'react';
import '../../assets/css/theme.css';
import '../../assets/css/cart.css';

const STEPS = ['Cart', 'Address', 'Payment', 'Summary'];
const TITLES = ['Shopping Cart', 'Delivery Address', 'Payment', 'Order Summary'];

interface CartBannerHeaderProps {
  /** 1 = Cart, 2 = Address, 3 = Payment, 4 = Summary */
  currentStep?: number;
}

const Check = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

/** Page header for the whole cart flow: eyebrow + title + 4-step progress. */
const CartBannerHeader = ({ currentStep = 1 }: CartBannerHeaderProps) => (
  <header className="ffc-head">
    <div className="ffc-container ffc-head-inner">
      <div>
        <p className="ffh-eyebrow ffh-eyebrow--light ffh-eyebrow--left">
          {currentStep < STEPS.length ? `Step ${currentStep} of ${STEPS.length}` : "You're all set"}
        </p>
        <h1 className="ffc-head-title">{TITLES[currentStep - 1] || TITLES[0]}</h1>
      </div>

      <ol className="ffc-steps" aria-label="Checkout progress" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {STEPS.map((label, idx) => {
          const stepNum = idx + 1;
          const isDone = stepNum < currentStep;
          const isActive = stepNum === currentStep;

          return (
            <React.Fragment key={label}>
              <li
                className={`ffc-step${isDone ? ' is-done' : ''}${isActive ? ' is-active' : ''}`}
                aria-current={isActive ? 'step' : undefined}
              >
                <span className="ffc-step-dot">{isDone ? <Check /> : stepNum}</span>
                <span className="ffc-step-label">{label}</span>
              </li>
              {idx < STEPS.length - 1 && <li aria-hidden="true" className={`ffc-step-line${isDone ? ' is-done' : ''}`} />}
            </React.Fragment>
          );
        })}
      </ol>
    </div>
  </header>
);

export default CartBannerHeader;